import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Collapse,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";
import CloseIcon from "@mui/icons-material/Close";
import boxStyles from "../../styles/boxStyles";
import SaveIcon from "@mui/icons-material/Save";
import ApiService from "../../services/ApiService";
import DataTable from "../../components/Table/DataTable";
import { useAuth } from "oidc-react";
import Create from "./create";
import Modal from "../../components/modal/modal";
import { LoadingButton } from "@mui/lab";

const MasterUserAdmin = () => {
  const router = useNavigate();
  const { userData } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [dataAdminUsers, setDataAdminUsers] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [user, setUser] = useState({
    namaPegawai: "",
    email: "",
    jabatan: "",
    noPegawai: "",
    roleId: "",
    activeStatus: "",
  });
  const [action, setAction] = useState("create");
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("md");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [pagination, setPagination] = useState("");

  const getAdminUsers = (payload) => {
    try {
      setIsLoading(true);
      ApiService.getAdminUsers(payload).then((res) => {
        if (res.data.isOk) {
          setDataAdminUsers(res.data.payload.data);
          setPagination(res.data.payload.pagination);
        } else {
          alert(res.data.message);
        }
        setIsLoading(false);
      });
    } catch (error) {
      alert("Error was occured!");
      // router("/");
    }
  };

  const getAdminUser = async (payload) => {
    try {
      setIsLoading(true);
      await ApiService.getAdminUsers(payload).then((res) => {
        if (res.data.isOk) {
          let result = res.data.payload.data[0];
          setUser({
            namaPegawai: result.namaLengkap,
            email: result.emailUser,
            jabatan: "",
            noPegawai: result.nopek,
            roleId: result.roleId,
            activeStatus: "",
          });
        } else {
          alert(res.data.message);
        }
        setIsLoading(false);
      });
    } catch (error) {
      alert("Error was occured!");
      setIsLoading(false);
      // router("/");
    }
  };

  useEffect(() => {
    let checkRole = localStorage.getItem("roleName");
    if (checkRole) {
      if (checkRole.replaceAll('"', "") == "USER_HIMS") {
        console.log("test");
        router("/hsse");
      }
    }

    getAdminUsers({
      page: 1,
      itemPerPage: 5,
      keyWord: "",
    });
  }, []);

  const changePaginate = (paginate) => {
    getAdminUsers({
      page: paginate.page,
      itemPerPage: paginate.rowsPerPage,
      keyWord: "",
    });
  };

  const newCol = useMemo(
    () => [
      {
        id: "no",
        label: "No",
      },
      {
        id: "namaLengkap",
        label: "Nama Pegawai",
      },
      {
        id: "emailUser",
        label: "Email",
      },
      {
        id: "nopek",
        label: "No. Pegawai",
      },
      {
        id: "roleName",
        label: "Role",
      },
      {
        id: "activeStatus",
        label: "Active Status",
      },
      {
        id: "action",
        label: "",
      },
    ],
    []
  );

  const [open, setOpen] = useState(false);
  const [inputFields, setInputFields] = useState({
    namaPegawai: "",
    email: "",
    jabatan: "",
    noPegawai: "",
    roleId: "",
    activeStatus: "",
  });

  const showModal = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleView = async (email) => {
    setIsSubmit(false);
    await getAdminUser({
      page: 1,
      itemPerPage: 5,
      keyWord: email,
    });
    console.log(email, "view");
    setAction("read");
    showModal();
  };

  const handleEdit = async (email) => {
    setIsSubmit(false);
    setAction("edit");
    await getAdminUser({
      page: 1,
      itemPerPage: 5,
      keyWord: email,
    });
    showModal();
  };

  const submit = () => {
    let errorSubmit = false;
    if (!inputFields.namaPegawai) {
      errorSubmit = true;
      setErrorMessage("Nama Pegawai Tidak Boleh Kosong!");
    } else if (!inputFields.email) {
      errorSubmit = true;
      setErrorMessage("Email Pegawai Tidak Boleh Kosong!");
    } else if (!inputFields.noPegawai) {
      errorSubmit = true;
      setErrorMessage("No Pegawai Tidak Boleh Kosong!");
    } else if (!inputFields.roleId) {
      errorSubmit = true;
      setErrorMessage("Role Tidak Boleh Kosong!");
    } else {
      setIsError(false);
      setOpenAlert(false);

      let submitData = {
        roleId: inputFields.roleId,
        nopek: inputFields.noPegawai,
        emailUser: inputFields.email,
        namaLengkap: inputFields.namaPegawai,
      };
      try {
        setIsSubmit(true);
        ApiService.postUpdateUserAdmin(submitData).then((res) => {
          if (res.data.isOk) {
            setOpen(false);
            getAdminUsers({
              page: 1,
              itemPerPage: 5,
              keyWord: "",
            });
          } else {
            setIsSubmit(false);
            alert(res.data.message);
          }
        });
      } catch (error) {
        alert("Error was occured!", error);
        // router("/");
      }
    }

    if (errorSubmit) {
      setOpenAlert(true);
      setIsError(true);
      return;
    }
  };

  const handleKeyDown = async (e) => {
    if (e.key == "Enter" || e.key == " ") {
      setIsLoading(true);
      try {
        setSearchVal(e.target.value);
        await getAdminUsers({
          page: 1,
          itemPerPage: 5,
          keyWord: e.target.value,
        });
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        alert("The Error was occured", error);
        setTimeout(() => {
          // router("/");
        }, 500);
      }
    }
  };

  const mainContainer = (
    <>
      <Modal
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        handleClose={handleClose}
        title={
          <>
            <div style={{ textAlign: "center" }}>
              {action == "read"
                ? "View"
                : action == "create"
                ? "Create"
                : action == "edit"
                ? "Edit"
                : ""}{" "}
              User Admin
            </div>
            {handleClose ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
            {isError ? (
              <Collapse in={openAlert}>
                <Alert
                  severity="error"
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setOpenAlert(false);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                >
                  <AlertTitle>Error</AlertTitle>
                  Error — <strong>{errorMessage}</strong>
                </Alert>
              </Collapse>
            ) : (
              ""
            )}
          </>
        }
        content={
          <>
            <Create
              inputFields={inputFields}
              setInputFields={setInputFields}
              readOnly={true}
              action={action}
              user={user}
            />
          </>
        }
        actions={
          <>
            <Button
              color="secondary"
              autoFocus
              variant="outlined"
              onClick={handleClose}
            >
              <span>{action == "read" ? "Close" : "Cancel"} </span>
            </Button>
            {action != "read" ? (
              isSubmit ? (
                <LoadingButton
                  loading
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="outlined"
                >
                  Save
                </LoadingButton>
              ) : (
                <Button autoFocus variant="contained" onClick={submit}>
                  <SaveIcon /> <span style={{ marginLeft: "5px" }}>Save</span>
                </Button>
              )
            ) : (
              ""
            )}
          </>
        }
      />
      <Grid container spacing={2} marginBottom={2}>
        <Grid item xs={6}>
          <TextField
            style={{ marginTop: "5px" }}
            id="outlined-basic"
            fullWidth
            label="Search by name"
            variant="outlined"
            size="small"
            onKeyDown={handleKeyDown}
            value={searchVal}
            onChange={(e) => {
              setSearchVal(e.target.value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Box
            m={1}
            display="flex"
            justifyContent="flex-end"
            alignItems="flex-end"
          >
            <Button
              variant="outlined"
              onClick={() => {
                showModal();
                setAction("create");
                setIsSubmit(false);
              }}
            >
              Add +
            </Button>
          </Box>
        </Grid>
      </Grid>

      <DataTable
        columns={newCol}
        rowsData={dataAdminUsers}
        changePaginate={changePaginate}
        showModal={showModal}
        handleView={handleView}
        handleEdit={handleEdit}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        pagination={pagination}
      />
    </>
  );

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 0,
      }}
    >
      <p>Login as {userData?.profile?.display_name}</p>
      <h1>User Admin Data</h1>
      <Box component="div" sx={boxStyles} id="tabel">
        {isLoading ? <LoadingSpinner /> : mainContainer}
      </Box>
    </Box>
  );
};

export default MasterUserAdmin;
